import styled from "styled-components";

export const QuiverContainer = styled.div`
  h3 {
    font-size: 24px;
    font-weight: 500;
  }
  .connection-form {
    margin-top: 20px;
    max-width: 400px;

    .form-label {
      color: ${({ theme }) => theme.card.font.tertiary};
      font-size: 14px;
      font-weight: 500;
    }

    .form-control {
      background: ${({ theme }) => theme.card.bg.primary};
      border: 1px solid ${({ theme }) => theme.card.border.quaternary};
      color: ${({ theme }) => theme.card.font.tertiary};
      border-radius: 25px;
      padding: 10px;

      &:focus {
        box-shadow: none;
        border-color: ${({ theme }) => theme.global.color.quinary};
      }
    }

    button {
      margin-top: 10px;
    }
  }
`;
